import { Box, Button, Paper, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AppConfig from '../AppConfig';
import React from 'react';

export default function NoOrganisation(props: { alignItems?: string }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: props.alignItems === 'left' ? 'flex-start' : 'center', pt: 2 }}>
      <Paper variant="outlined" sx={{ maxWidth: 560, p: { xs: 3, sm: 4 }, borderRadius: 3 }}>
        <Typography component="h2" sx={{ fontSize: '1.2rem', fontWeight: 600 }}>
          Connect your first Xero organisation
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          BAS Ready reads your clients' Xero files to show what's ready for BAS each period.
        </Typography>
        <Box component="ul" sx={{ pl: 2.5, my: 2, color: 'text.secondary', fontSize: '0.9rem', '& li': { mb: 0.5 } }}>
          <li>If you're the first in your firm to connect a client, you're set as its client manager.</li>
          <li>Clients that report PAYGW monthly need their PAYGW period changed on the Organisations page.</li>
        </Box>
        <Button variant="contained" startIcon={<AddIcon />} href={AppConfig.oauthConnectionsPath}>
          Connect Xero organisations
        </Button>
      </Paper>
    </Box>
  );
}
